(function () {
  const initSlider = (slider) => {
    if (!slider || slider.swiper) return;

    const panel = slider.closest(".home-product-collection__panel");

    if (!panel) return;

    const columns = parseInt(slider.dataset.columns, 10) || 4;
    const navigation = panel.querySelector(".home-product-collection__navigation");

    new Swiper(slider, {
      slidesPerView: 1.2,
      spaceBetween: 16,
      speed: 600,
      navigation: navigation
        ? {
            nextEl: navigation.querySelector(".swiper-button-next"),
            prevEl: navigation.querySelector(".swiper-button-prev"),
          }
        : false,
      breakpoints: {
        576: {
          slidesPerView: Math.min(2, columns),
          spaceBetween: 24,
        },
        750: {
          slidesPerView: Math.min(3, columns),
          spaceBetween: 24,
        },
        990: {
          slidesPerView: Math.min(4, columns),
          spaceBetween: 24,
        },
        1200: {
          slidesPerView: Math.min(5, columns),
          spaceBetween: 32,
        },
        1360: {
          slidesPerView: columns,
          spaceBetween: 32,
        },
      },
    });
  };

  const initActivePanelSlider = (section) => {
    const activePanel = section.querySelector(".home-product-collection__panel.is-active");

    if (!activePanel) return;

    activePanel.querySelectorAll(".home-product-collection__slider").forEach(initSlider);
  };

  const initTabs = (section) => {
    const tabs = section.querySelectorAll(".home-product-collection__tab");
    const panels = section.querySelectorAll(".home-product-collection__panel");

    if (!tabs.length || !panels.length) return;

    const activateTab = (tabId) => {
      tabs.forEach((tab) => {
        const isActive = tab.dataset.tabId === tabId;

        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
      });

      panels.forEach((panel) => {
        panel.classList.toggle("is-active", panel.dataset.panelId === tabId);
      });

      // Initialize the newly-activated panel's slider (was hidden, so it wasn't initialized yet).
      initActivePanelSlider(section);
    };

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => activateTab(tab.dataset.tabId));
    });

    const tabsList = section.querySelector(".home-product-collection__tabs");

    if (tabsList) {
      tabsList.addEventListener("keydown", (event) => {
        const currentIndex = Array.prototype.indexOf.call(tabs, document.activeElement);

        if (currentIndex === -1) return;

        let targetIndex = null;

        if (event.key === "ArrowRight") {
          targetIndex = (currentIndex + 1) % tabs.length;
        } else if (event.key === "ArrowLeft") {
          targetIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        }

        if (targetIndex === null) return;

        event.preventDefault();
        const targetTab = tabs[targetIndex];
        targetTab.focus();
        activateTab(targetTab.dataset.tabId);
      });
    }
  };

  const initHomeProductCollection = (section) => {
    if (!section || !section?.classList.contains("home-product-collection-section"))
      return;

    initTabs(section);
    initActivePanelSlider(section);
  };

  initHomeProductCollection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (e) {
    initHomeProductCollection(e.target);
  });
})();
